import React, { Component } from 'react';

import SponsorTable from './SponsorTable';
import SponsorEditor from './SponsorEditor';

const blankSponsor = {
  _id: undefined,
  title: undefined,
  image: undefined,
  url: undefined,
  user: undefined,
  active: true,
  createdAt: undefined,
};

class Sponsor extends Component {
  state = {
    showEditor: false,
    sponsor: { ...blankSponsor },
    editorType: null,
  }

  handleShowEditor = (sponsor) => {
    let info;
    let type;
    if (sponsor) {
      type = 'edit';
      info = { ...sponsor };
    } else {
      type = 'create';
      info = { ...blankSponsor };
    }
    this.setState({
      showEditor: true,
      sponsor: info,
      editorType: type,
    });
  }

  handleCloseEditor = () => {
    this.setState({
      showEditor: false,
      sponsor: { ...blankSponsor },
      editorType: undefined,
    });
  }

  render() {
    const { showEditor, sponsor, editorType } = this.state;
    const { formItemLayout, tailFormItemLayout } = this.props;

    return (
      <React.Fragment>
        <SponsorTable showEditor={this.handleShowEditor} />
        <SponsorEditor
          sponsor={sponsor}
          showEditor={showEditor}
          type={editorType}
          closeEditor={this.handleCloseEditor}
          formItemLayout={formItemLayout}
          tailFormItemLayout={tailFormItemLayout}
        />
      </React.Fragment>
    );
  }
}

export default Sponsor;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/Tabs/Sponsor/Sponsor.js